<template>
  <div class="home">
    <a-row v-if="!computedSession.isLoggedIn" :gutter="[16, 16]">
      <a-col :span="24">
        <a-card class="header">
          <a-row :gutter="[16, 16]" align="middle" justify="center" type="flex">
            <a-col :lg="10" :md="24" :sm="24" :xl="10" :xs="24" :xxl="8">

              <h1 class="header-text">
                <span style="color: #1890ff">Darmowy</span> internet <span class="no-orphan">z
                prędkością</span> <span style="color: #faad14">światła</span>!
              </h1>
              <p class="sub-header-text">Wypełnij wniosek lub <a href="#" @click="() => goTo('Login')">zaloguj
                się</a>* do konta już teraz. To
                <strong>mega
                  proste</strong> i przyjemne!
              </p>
              <a-button size="large" style="padding-left: 2em; padding-right: 2em; margin-bottom: 0.5em; font-weight: 500; font-size: 1.2em;"
                        type="primary"
                        @click="() => goTo('Form')">REJESTRUJĘ
                SIĘ!
              </a-button>
              <p style="max-width: 240px; opacity: 0.8"><small class="sub-header-text">* jeśli składałaś(eś) wniosek
                <span class="no-orphan">w
                    poprzedniej</span>
                wersji systemu <span class="no-orphan">to konto</span> musisz założyć od nowa</small></p>

            </a-col>
            <a-col :lg="14" :md="0" :sm="0" :xl="14" :xs="0" :xxl="16">
              <VueLottiePlayer :animationData="require('@/assets/computer.json')" :width="'auto'" loop
                               name="Server Animation" style="height: 100%; max-height: 500px;"/>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="[16, 16]">
      <a-col :span="24">
        <a-card>
          <NetworkStatus/>
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="[16, 16]">
      <a-col :lg="24" :md="24" :sm="24" :xl="10" :xs="24" :xxl="8">
        <a-card>
          <DeviceInfo/>
        </a-card>

        <!-- <a-card style="margin-top: 16px">
          <a-row type="flex" justify="space-between" style="text-align: center">
            <a-col :span="12">
              <a-avatar
                :size="64"
                style="
                  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
                  user-select: none;
                "
              >
                <img slot="icon" src="@/assets/poland.png" alt="Polish" />x
              </a-avatar>
            </a-col>
            <a-col :span="12">
              <a-avatar
                :size="64"
                style="
                  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
                  user-select: none;
                "
              >
                <img slot="icon" src="@/assets/uk.png" alt="English" />
              </a-avatar>
            </a-col>
          </a-row>
        </a-card> -->

        <!-- <a-card style="margin-top: 16px">
          <ServerStatus />
        </a-card> -->
        <!-- <a-row style="margin-top: 16px">
          <a-alert
            type="info"
            message="Pliki cookies"
            description="Strona wykorzystuje pliki cookies tylko do obsługi kont użytkownika."
            show-icon
            style="
              border-radius: 12px;
              box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.1);
            "
          />
        </a-row> -->
      </a-col>
      <a-col :lg="24" :md="24" :sm="24" :xl="14" :xs="24" :xxl="16">
        <a-empty v-if="newsList.length === 0" description="Brak wiadomości"/>
        <News v-for="news in newsList" v-else :key="news.id" :author="news.author" :content="news.content"
              :newsType="news.category" :publishedDate="news.publishedDate" :title="news.title"/>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import httpClient from "../utils/httpClient";
import News from "@/components/News.vue";
import NetworkStatus from "@/components/network/NetworkStatus.vue";
import DeviceInfo from "@/components/network/DeviceInfo";
import VueLottiePlayer from "vue-lottie-player";

export default {
  name: "Home",
  data() {
    return {
      newsList: [],
    };
  },
  components: {
    News,
    DeviceInfo,
    NetworkStatus,
    VueLottiePlayer
  },
  mounted() {
    this.$emit("loadedView");
    this.getNews();
  },
  computed: {
    computedSession: function () {
      return this.$store.getters.getUserConnectionDetails;
    },
  },
  methods: {
    getNews: function () {
      httpClient
          .get("/news")
          .then((response) => {
            this.newsList = response;
          });
    },
    goTo: function (name) {
      this.$router.push({name: name});
    },
  },
};
</script>

<style scoped>
.header {
  background: rgb(0, 33, 61);
  background: linear-gradient(120deg, rgba(0, 22, 40, 1) 5%, rgba(25, 144, 255, 1) 200%);
  padding: 2vh 5vw;
}

@media screen and (min-width: 992px) {
  .header {
    background: rgb(0, 33, 61);
    background: linear-gradient(120deg, rgba(0, 22, 40, 1) 10%, rgba(25, 144, 255, 1) 120%);
    padding: 1vh 10vw;
  }
}

.header-text {
  font-size: 3em;
  color: #ffffff;
  text-shadow: 1px 1px 0px rgba(0, 0, 75, 1),
  2px 2px 0px rgba(0, 0, 75, 1),
  3px 3px 0px rgba(0, 0, 75, 1),
  4px 4px 0px rgba(0, 0, 75, 1),
  5px 5px 0px rgba(0, 0, 75, 1);
}

.sub-header-text {
  color: #ffffff;
  text-shadow: 1px 1px 0px rgba(0, 0, 75, 1),
  2px 2px 0px rgba(0, 0, 75, 1),
  3px 3px 0px rgba(0, 0, 75, 1);
}
</style>